import React from 'react';
import { Checkbox } from 'react-frontier';
import BusinessAccess from '../BusinessAccess';
import { partition } from '@tempu/components/Util';

interface UserAccessConfigProps {
   accesss: number[],
   onAccessChange: (acc: number[]) => void,
   style?: React.CSSProperties,
   admin: boolean,
   hasAdminAccess: boolean
}

var UserAccessConfig = (props: UserAccessConfigProps) => {
   var getVisibleAccess = (category: any) => {
      if (props.admin) {
         return category.access.filter((a: any) => a.reserved);
      }
      return category.access.filter((a: any) => {
         return !a.restricted || (a.restricted && props.hasAdminAccess);
      });
   }

   var isCategoryChecked = (category_id: number) => {
      var cat = BusinessAccess.ACCESS_ARRAY.find(a => a.id == category_id);
      if (!cat || cat.access.length == 0) return false;
      var visibleAccess = getVisibleAccess(cat);
      if (visibleAccess.length === 0) return false;
      var cat_acc = visibleAccess.map((a: any) => a.id);
      for (var i of cat_acc) {
         if (props.accesss.indexOf(i) == -1) return false;
      }
      return true;
   }

   var onCategoryChecked = (category_id: number) => {
      return (checked: boolean) => {
         var cat = BusinessAccess.ACCESS_ARRAY.find(a => a.id == category_id);
         if (!cat || cat.access.length == 0) return;
         var visibleAccess = getVisibleAccess(cat);
         if (visibleAccess.length === 0) return;
         var cat_acc = visibleAccess.map((a: any) => a.id);
         var new_acc = [...props.accesss];
         if (checked) {
            for (var i of cat_acc) {
               if (new_acc.indexOf(i) == -1) {
                  new_acc.push(i);
               }
            }
         } else {
            new_acc = new_acc.filter(a => cat_acc.indexOf(a) == -1);
         }
         props.onAccessChange(new_acc);
      }
   }

   var onAccessChange = (access: number) => {
      return (checked: boolean) => {
         if (props.accesss.indexOf(access) == -1) {
            if (!checked) return;
            props.onAccessChange([...props.accesss, access]);
         } else {
            if (checked) return;
            props.onAccessChange(props.accesss.filter(a => a !== access));
         }
      }
   }

   var getAccessLabelStyle = (access: any) => {
      if (access.reserved) {
         return { color: 'red' };
      }
      return {};
   }

   return (
      <div className="tp user-access-config" style={props.style}>
         {BusinessAccess.ACCESS_ARRAY.map(a => {
            const visibleAccess = getVisibleAccess(a);
            if (visibleAccess.length === 0) return null;

            return (
               <div className="category" key={`BSUSR-ACC-CFG-${a.id}`}>
                  <div className="header">
                     <Checkbox
                        label={a.name}
                        color='red'
                        checked={isCategoryChecked(a.id)}
                        onChange={onCategoryChecked(a.id)}
                     />
                  </div>
                  {partition(visibleAccess, 2).map((b: any[]) => (
                     <div className="access" key={`BSUSR-ACC-${b[0].id}`}>
                        <div className="item">
                           <Checkbox
                              checked={props.accesss.indexOf(b[0].id) != -1}
                              color='blue'
                              label={b[0].name}
                              onChange={onAccessChange(b[0].id)}
                              labelStyle={getAccessLabelStyle(b[0])}
                           />
                        </div>
                        {b.length > 1 && (
                           <div className="item">
                              <Checkbox
                                 checked={props.accesss.indexOf(b[1].id) != -1}
                                 label={b[1].name}
                                 onChange={onAccessChange(b[1].id)}
                                 labelStyle={getAccessLabelStyle(b[1])}
                              />
                           </div>
                        )}
                     </div>
                  ))}
               </div>
            )
         })}
      </div>
   )
}

export default UserAccessConfig;
